import setupStore from "./setupStore";
import store from "@/store";

export default {
  install() {
    store.registerModule("Setup", setupStore);
  },
};
